export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43104456245319:1',
  premium: 'https://www.compradigitalya.com/cart/43104456802375:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/9oJ3TzxARK9WeafFRkPBPa/ChatGPT_Image_17_ago_2026,_08_07_35_p.m..png'

export const shortTestimonials = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    place: 'Córdoba',
    text: 'Organicé todo el año en una tarde. Ya no improviso el domingo a la noche.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    place: 'Rosario',
    text: 'Mis alumnas avanzan de forma visible. Los tomos de aparatos son el hit de la clase.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    place: 'Buenos Aires',
    text: 'El Bono de Secuencias vale cada peso. Mis clases avanzadas por fin tienen estructura.',
  },
]

export const fullTestimonials = [
  {
    initials: 'MG',
    name: 'Mariela González',
    place: 'Córdoba · 38 años · Profesora de Gimnasia Rítmica',
    text: 'Doy rítmica hace 12 años y siempre armaba las clases el domingo a la noche. Con el Tomo 6 planifiqué los 12 meses en una sola tarde y ahora abro la carpeta y la clase ya está. Lo primero que noté no fue el tiempo que gané: fue llegar al lunes tranquila, sabiendo exactamente qué iba a trabajar con cada grupo.',
  },
  {
    initials: 'LP',
    name: 'Laura Pérez',
    place: 'Rosario · 29 años · Profesora de Educación Física y rítmica',
    text: 'Los aparatos eran mi punto débil: cinta y mazas siempre terminaban en lo mismo. Los Tomos 4 y 5 me dieron progresiones reales de lanzamiento y recepción, con las correcciones escritas al lado. En dos meses mis alumnas de intermedio hacen combinaciones que antes no me animaba a enseñar.',
  },
  {
    initials: 'SC',
    name: 'Sofía Castro',
    place: 'Buenos Aires · 24 años · Profesora de nivel iniciación',
    text: 'Arranqué dando clases el año pasado y me sentía perdida con los grupos de 6 y 7 años. El Tomo 1 y el bono de Juegos me salvaron: tengo 80 actividades ordenadas por objetivo técnico, así que las nenas juegan y a la vez aprenden a coordinar. Los padres me preguntan qué método uso.',
  },
  {
    initials: 'VL',
    name: 'Valentina Ledesma',
    place: 'Mendoza · 33 años · Entrenadora de grupo competitivo',
    text: 'Tengo un grupo que compite y otro formativo en el mismo horario. Con las variantes por nivel de cada ficha trabajo a las dos a la vez sin dejar a nadie afuera. Rítmica Élite además me ordenó la preparación de la competencia: simulación, tapering y análisis después. Dejé de improvisar en la semana más importante del año.',
  },
  {
    initials: 'CR',
    name: 'Carolina Ríos',
    place: 'La Plata · 45 años · Directora de escuela de rítmica',
    text: 'Compré el pack pensando en mí y terminó siendo el material de todo mi equipo. Las tres profes trabajan con las mismas progresiones y checklists, así que cuando una falta, la clase sigue igual. La evaluación anual del Planificador fue lo que más me sorprendió: por fin puedo mostrarle a cada familia el avance real de su hija.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Fundamentos en Acción',
    period: 'Primeras clases listas desde el día uno',
    content: [
      'Calentamientos específicos de rítmica listos para aplicar.',
      'Coordinación, ritmo y conciencia corporal en la iniciación.',
      'Primeras clases completas armadas de principio a fin.',
      'Consignas verbales para grupos de 5 a 8 años.',
    ],
  },
  {
    icon: '📗',
    name: 'Cuerpo de Gimnasta',
    period: 'Fuerza, movilidad y flexibilidad',
    content: [
      'Protocolo físico completo con progresiones por nivel.',
      'Fuerza de core, pies y espalda aplicada a la rítmica.',
      'Movilidad de cadera, hombros y columna paso a paso.',
      'Rutinas cortas para insertar en cualquier clase.',
    ],
  },
  {
    icon: '📙',
    name: 'Técnica Corporal',
    period: 'Saltos, giros y equilibrios',
    content: [
      'Progresión técnica real de saltos, giros y equilibrios.',
      'Correcciones específicas por elemento, escritas al lado.',
      'Errores frecuentes y cómo detectarlos a simple vista.',
      'Criterios claros para pasar de una etapa a la siguiente.',
    ],
  },
  {
    icon: '📕',
    name: 'Aparatos I',
    period: 'Cinta, aro y pelota',
    content: [
      'Técnica de base de cinta, aro y pelota.',
      'Lanzamientos y recepciones con progresión segura.',
      'Combinaciones cuerpo-aparato por nivel.',
      'Clases completas por aparato, listas para usar.',
    ],
  },
  {
    icon: '📓',
    name: 'Aparatos II',
    period: 'Mazas, cuerda e integración',
    content: [
      'Técnica de mazas y cuerda desde cero.',
      'Integración cuerpo-aparato en nivel intermedio y avanzado.',
      'Molinos, coordinaciones y series encadenadas.',
      'Variantes para grupos con distintos niveles.',
    ],
  },
  {
    icon: '📔',
    name: 'El Año Completo',
    period: 'Planificación anual de 12 meses',
    content: [
      'Planificación anual mes a mes lista para aplicar.',
      'Clases semanales armadas para todo el ciclo.',
      'Objetivos por trimestre y por nivel.',
      'Evaluaciones integradas al calendario del año.',
    ],
  },
]

export const tomoIncludes = [
  'Clases completas listas para usar',
  'Fichas con progresión paso a paso',
  'Correcciones específicas por elemento',
  'Tablas de progresión y checklists',
  'Banco de consignas verbales',
  'Planificación mensual lista para aplicar',
]

export const bonuses = [
  [
    '01',
    '🏋️',
    'Banco de Preparación Física',
    'Fuerza, core, pies, potencia y coordinación con circuitos organizados por nivel.',
    '$12.000',
  ],
  [
    '02',
    '🤸',
    'Flexibilidad Total',
    'Progresiones completas hacia el split y la amplitud máxima, sin forzar etapas.',
    '$10.000',
  ],
  [
    '03',
    '🎀',
    'Mega Banco de Aparatos',
    'Biblioteca completa de los 5 aparatos con variantes por nivel y por objetivo.',
    '$14.000',
  ],
  [
    '04',
    '🎲',
    'Juegos y Dinámicas',
    '80 actividades lúdicas organizadas por objetivo técnico, ideales para iniciación.',
    '$9.000',
  ],
  [
    '05',
    '⭐',
    'Secuencias Élite',
    'Banco de secuencias técnicas listas para aplicar en grupos avanzados.',
    '$12.000',
  ],
  [
    '06',
    '📊',
    'Planificador Profesional',
    'Sistema completo de planificación y evaluación anual, listo para imprimir.',
    '$9.000',
  ],
] as const

export const eliteRows = [
  [
    'Repetís los mismos ejercicios con alumnas avanzadas',
    'Progresiones élite para habilidades complejas',
  ],
  [
    'Improvisás correcciones de giros dobles y triples',
    'Fichas técnicas específicas con diagnóstico',
  ],
  [
    'Sin protocolo de preparación competitiva',
    'Simulación, tapering y análisis post-competencia',
  ],
  [
    'Aparatos sin especificidad de nivel élite',
    'Riesgos, maestrías y coordinaciones complejas',
  ],
] as const

export const eliteIncludes = [
  'Progresiones élite',
  'Fichas de diagnóstico técnico',
  'Giros dobles y triples',
  'Protocolo pre-competencia',
  'Simulación y tapering',
  'Análisis post-competencia',
  'Riesgos y maestrías de aparato',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Desde la iniciación absoluta hasta el nivel avanzado y competitivo. Cada ficha indica el nivel y trae variantes, así que podés tener grupos mixtos y trabajar con todas en la misma clase.',
  ],
  [
    '¿Cómo recibo el material?',
    'Por email en menos de 5 minutos después de la compra. Es 100% PDF descargable: lo imprimís, lo usás en la tablet o en el teléfono a pie de colchoneta.',
  ],
  [
    '¿Qué diferencia tiene con el material gratuito que hay en internet?',
    'El material gratuito son ejercicios sueltos: no tiene progresión, no tiene correcciones y no tiene clases completas. Esto es un sistema diseñado para profesoras que trabajan en Argentina con grupos reales, con la clase ya armada de principio a fin.',
  ],
  [
    '¿La garantía es real?',
    '7 días, devolución del 100% sin preguntas. No es decorativa: escribís un mail y te devolvemos el dinero. Sin formularios y sin drama.',
  ],
  [
    '¿Necesito los 5 aparatos para empezar?',
    'No. Los Tomos 1, 2 y 3 son íntegramente de trabajo corporal. Los tomos de aparatos incluyen variantes con material básico y adaptaciones para clubes y colegios con equipamiento limitado.',
  ],
  [
    '¿Cuánto tardo en armar una clase con el material?',
    'Entre 5 y 10 minutos. Elegís el nivel, tomás la clase del mes que corresponde y ya está cerrada. Con el Tomo 6 y el Planificador directamente seguís el calendario.',
  ],
  [
    '¿Sirve si doy clases en colegio o escuelita municipal y no en club competitivo?',
    'Sí, es su uso más frecuente. Las clases están pensadas para grupos numerosos, con juegos, rotación y consignas simples, sin necesitar un gimnasio de alto rendimiento.',
  ],
  [
    '¿Incluye correcciones técnicas de cada elemento?',
    'Sí. Cada elemento corporal y de aparato trae los errores frecuentes, la corrección concreta y la consigna verbal exacta para decirle a la alumna en el momento.',
  ],
  [
    '¿Me sirve si tengo alumnas que compiten?',
    'Sí. Las progresiones llegan a nivel avanzado y el bono de Secuencias Élite suma series listas. Si además querés el año competitivo ordenado, la opción con Rítmica Élite incluye el protocolo de preparación, simulación y análisis post-competencia.',
  ],
  [
    '¿Está adaptado a Argentina y puedo imprimirlo?',
    'Sí a las dos cosas. Terminología, ejemplos y calendario están adaptados al ciclo lectivo argentino, y todos los PDF están optimizados para imprimir, incluidas las fichas y planillas de evaluación.',
  ],
] as const

export const recentPurchases = [
  ['Mariela G.', 'Córdoba', 'Gimnasia Rítmica PRO'],
  ['Laura P.', 'Rosario', 'Gimnasia Rítmica PRO + Élite'],
  ['Sofía C.', 'Buenos Aires', 'Gimnasia Rítmica PRO'],
  ['Valentina L.', 'Mendoza', 'Gimnasia Rítmica PRO + Élite'],
  ['Carolina R.', 'La Plata', 'Gimnasia Rítmica PRO'],
  ['Julieta F.', 'San Miguel de Tucumán', 'Gimnasia Rítmica PRO'],
  ['Agustina M.', 'Mar del Plata', 'Gimnasia Rítmica PRO + Élite'],
  ['Rocío B.', 'Neuquén', 'Gimnasia Rítmica PRO'],
  ['Daniela S.', 'Salta', 'Gimnasia Rítmica PRO + Élite'],
  ['Belén T.', 'Bahía Blanca', 'Gimnasia Rítmica PRO'],
] as const
